import React from 'react';
import { classNames } from 'primereact/utils';

// @ts-ignore
import emptyProductsIcon from '../../assets/images/planograms/empty-products.svg';

// @ts-ignore
import './EmptyBlock.scss';

export type EmptyBlockVariant = 'default' | 'warning';

export interface EmptyBlockProps {
    icon?: React.ReactNode;
    title: React.ReactNode;
    description?: React.ReactNode;
    variant?: EmptyBlockVariant;
    className?: string;
    iconClassName?: string;
    titleClassName?: string;
    messageClassName?: string;
    showWarningIcon?: boolean;
}

const WarningIcon = () => (
    <img
        className="empty-block__warning-icon"
        src={emptyProductsIcon}
        alt=""
        aria-hidden="true"
    />
);

const EmptyBlock = ({
    icon,
    title,
    description,
    variant = 'warning',
    className,
    iconClassName,
    titleClassName,
    messageClassName,
    showWarningIcon = true,
}: EmptyBlockProps) => (
    <div className={classNames('empty-block', `empty-block--${variant}`, className)}>
        <div className={classNames('empty-block__icon', iconClassName)}>
            {icon || <img src={emptyProductsIcon} alt="" />}
        </div>

        <h4 className={classNames('empty-block__title', titleClassName)}>
            {title}
        </h4>

        {description && (
            <div className={classNames('empty-block__message', messageClassName)}>
                <p>
                    {showWarningIcon && <WarningIcon />}
                    <span>{description}</span>
                </p>
            </div>
        )}
    </div>
);

export default EmptyBlock;